import React from "react";
import Styled from "styled-components";
import TableReadEditCell from "../../components/TableReadEditCell";
const Table = Styled.table`
	width:98%;
	margin:0.7rem auto;
	border: 1px solid black;


    th{
        font-size: 13px;
		    font-family:"Roboto",sans-serif;
        border: 1px solid black;
        padding: 0.4rem;
        p{
          margin:0;
        }
        
    }
    td{
        font-size: 13px;
        border: 1px solid black;
        padding: 0.3rem;
    }
    .input {
        outline: none;
        width: 100%;
        border: none;
        padding-left: 4px;
        height: 40px;
    }
`;

const heading = {
  "annexure-a": "ANNEXURE A",
  "annexure-b": "ANNEXURE B",
  "annexure-c": "ANNEXURE C",
};

const AnnexureAForm = ({ id, data, handleChange, isView, annexureType, additionalRows }) => {
  return (
    <section>
      <Table>
        <tr>
          <th
            colSpan={2}
            style={{
              fontSize: "1.2rem",
              fontWeight: 600,
              backgroundColor: "#1d1d1d",
              color: "white",
              border: "1px solid black",
              textAlign: "center",
            }}
          >
            {heading[annexureType]}
          </th>
        </tr>
        <tr>
          <td>Wire Diameter</td>
          <td>
            <TableReadEditCell
              required
              type="text"
              name="wire_dia"
              value={data.wire_dia}
              isView={isView}
              {...{ handleChange }}
            />
          </td>
        </tr>
        <tr>
          <td>Wire Tensile</td>
          <td>
            <TableReadEditCell
              type="text"
              required
              name="wire_tensile"
              value={data.wire_tensile}
              isView={isView}
              {...{ handleChange }}
            />
          </td>
        </tr>
        <tr>
          <td>Shank Diameter</td>
          <td>
            <TableReadEditCell
              type="text"
              required
              name="annex_a_shank_dia"
              value={data.annex_a_shank_dia}
              isView={isView}
              {...{ handleChange }}
            />
          </td>
        </tr>
        <tr>
          <td>Length</td>
          <td>
            <TableReadEditCell
              type="text"
              required
              name="annex_a_length"
              value={data.annex_a_length}
              isView={isView}
              {...{ handleChange }}
            />
          </td>
        </tr>
        <tr>
          <td>Head Dia</td>
          <td>
            <TableReadEditCell
              type="text"
              name="head_dia"
              required
              value={data.head_dia}
              isView={isView}
              {...{ handleChange }}
            />
          </td>
        </tr>
        <tr>
          <td>Head Thickness</td>
          <td>
            <TableReadEditCell
              type="text"
              required
              name="head_thickness"
              value={data.head_thickness}
              isView={isView}
              {...{ handleChange }}
            />
          </td>
        </tr>
        <tr>
          <td>Internal Diameter</td>
          <td>
            <TableReadEditCell
              type="text"
              name="internal_dia"
              required
              value={data.internal_dia}
              isView={isView}
              {...{ handleChange }}
            />
          </td>
        </tr>
        <tr>
          <td>Hole Eccentricity</td>
          <td>
            <TableReadEditCell
              type="text"
              name="hole_eccentricity"
              value={data.hole_eccentricity}
              required
              isView={isView}
              {...{ handleChange }}
            />
          </td>
        </tr>
        <tr>
          <td>Head Eccentricity</td>
          <td>
            <TableReadEditCell
              type="text"
              name="head_eccentricity"
              required
              value={data.head_eccentricity}
              isView={isView}
              {...{ handleChange }}
            />
          </td>
        </tr>
        <tr>
          <td>Appearance</td>
          <td>
            <TableReadEditCell
              type="text"
              name="appearance"
              isView={isView}
              required
              {...{ handleChange }}
              value={data.appearance}
            />
          </td>
        </tr>
        <tr>
          <td>Radius</td>
          <td>
            <TableReadEditCell
              type="text"
              name="radius"
              isView={isView}
              required
              {...{ handleChange }}
              value={data.radius}
            />
          </td>
        </tr>
        {additionalRows}
      </Table>
    </section>
  );
};

export default AnnexureAForm;
